import React from 'react';
import { Container, Row } from 'reactstrap';
import FrequencyReport from './components/FrequencyReport';

export default function FrequencyReportIndex() {
  return (
    <Container className="dashboard">
      <Row>
        <FrequencyReport title="AMC Frequency Report" />
      </Row>
    </Container>
  );
}
